module.exports = __webpack_public_path__ + "static/media/quote_bg_2.f342bf1d.png";